export default {
  urlServer: process.env.REACT_APP_SWIZI_URL,
  urlCountly: process.env.REACT_APP_COUNTLY_URL,
  appsEntryPoint: 'app/',
  deployEntryPoint: 'deploy/',
  localeEntryPoint: 'locales/',
  usersEntryPoint: 'userfo/',
  libraryEntryPoint: 'media/',
  iconEntryPoint: 'icon/list/',
  iconUploadEntryPoint: 'icon/add',
  iconsDownloadEntryPoint: 'icon/download',
  iconsTagsEntryPoint: 'icon/tags',
  iconsSearchTagsEntryPoint: 'icon/tag',
  iconsEntryPoint: 'icon/page/',
  iconDetailEntryPoint: 'icon/content/',
  imagesUploadEntryPoint: 'library/add',
  imagesDownloadEntryPoint: 'library/download',
  imagesTagsEntryPoint: 'library/tags',
  imagesSearchTagsEntryPoint: 'library/tag',
  imageDetailEntryPoint: 'library/content/',
  groupEntryPoint: 'group/',
  userWSEntryPoint: 'userws/',
  userFOEntryPoint: 'userfo/',
  teamEntryPoint: 'team/',
  notifEntryPoint: 'notif/',
  iotBeaconEntryPoint: 'iot/beacon/',
  sectionEntryPoint: 'section/',
  sectionTagsEntryPoint: 'section/tags/',
  contentEntryPoint: 'content/',
  siteEntryPoint: 'site/',
  sessionEntryPoint: 'session/',
  styleEntryPoint: 'style/',
  planEntryPoint: 'plan/',
  mapEntryPoint: 'poi/',
  typesEntryPoint: 'typePoi/',
  mapWizeEntryPoint: 'mapwize/',
  zoneEntryPoint: 'zone/',
  socialWallEntryPoint: 'socialwall/',
  quizzEntryPoint: 'question/',
  questionToSpeakerEntryPoint: 'questionToSpeaker/',
  storeEntryPoint: 'store/',
  mediaEntryPoint: 'media/',
  mediaMiniature: 'media/miniature/',
  mediaContent: 'media/content/',
  mediaTotalSize: 'media/totalSize/',
  mediaUpload: 'media/importMedias/',
  mediaDownloadAll: 'media/exportMedias/',
  mediaTags: 'media/tags',
  raEntryPoint: 'ra/',
  addressBookEntryPoint: 'annuaire/',
  pluginEntryPoint: 'plugin/',
  pluginLogo: 'plugin/logo/',
  profilEntryPoint: 'profile/',
  apiKeyEntryPoint: 'apiKey/',
  corsEntryPoint: 'cors/',
  keyvalueEntryPoint: 'keyValue/',
  apikeyvalueEntryPoint: 'dataApi/',
  filesEntryPoint: 'dataFile/',
  plannersEntryPoint: 'dataPlanner/',
  checkinsEntryPoint: 'dataCheckin/',
  chatsEntryPoint: 'dataChat/',
  resourceManagersEntryPoint: 'dataResourceManager/',
  formsEntryPoint: 'dataForm/',
  genericsEntryPoint: 'dataGeneric/',
  dmsEntryPoint: 'dataDM/',
  authTokenParam: '?authtoken=',
  header: {
    'Content-Type': 'application/json',
    'authtoken': null,
    'refreshtoken': null,
  },
  headerFormData: {
    'Content-Type': 'multipart/form-data',
    'authtoken': null,
    'refreshtoken': null,
  },
  urlViewerIos: 'https://player.swizi.io/',
  urlViewerAndroid: 'https://play.google.com/store/apps/details?id=com.swizi.player',
  forms: {
    formBaseUrl: '/api/v1/form',
  },
  chat: {
    addRoom: '/api/room/add',
    updateRoom: '/api/room/update',
    listRoom: '/api/room/list',
    removeRoom: '/api/room/remove',
    detailRoom: '/api/room/get',
    subscription: '/api/user/list',
    subscribe: '/api/subscription/add/group',
  },
  faqUrl: 'https://swizi.open.global/faq',
  releaseNote: 'https://release-note.swizi.io',
}
